import { useUser } from "auth";
import CenterColumn from "components/CenterColumn";
import NavBar from "components/NavBar";
import { PageHeader } from "components/PageHeader";
import { Route, Switch } from "react-router";
import { DeliverySettings } from "./DeliverySettings";
import { ProfileSettings } from "./ProfileSettings";
import { SessionSettings } from "./SessionSettings";

const AccountSettings = () => {
  const [user] = useUser();

  const navLinks = [
    {
      label: "Profile",
      url: "/account-settings",
      exact: true,
    },
    user.permissions.includes("community") && {
      label: "Magazine",
      url: "/account-settings/delivery",
    },
  ].filter(Boolean);

  return (
    <CenterColumn>
      <PageHeader
        text="Account settings"
        subtitle="Edit your public profile here"
      />
      <NavBar links={navLinks} activeColor="primary" />
      <Switch>
        <Route path="/account-settings" exact>
          <ProfileSettings />
          <SessionSettings />
        </Route>
        {user.permissions.includes("community") && (
          <Route
            path="/account-settings/delivery"
            exact
            component={DeliverySettings}
          />
        )}
      </Switch>
    </CenterColumn>
  );
};

export default AccountSettings;
